import { Component, OnInit, ViewChild, ElementRef, HostListener, Input, EventEmitter, Output } from '@angular/core';
import { GraphLayoutDetail } from '../../../_models/Questions/question.interface';
import { GraphPoints, Coordinates } from "../../../_models/Questions/GraphLayoutDetails/graphLayoutDetails";
import { QuestionInfo } from '../../../_models/Question';
@Component({
    selector: 'app-graph',
    templateUrl: './GraphInteraction.component.html',
    styleUrls: ['./GraphInteraction.component.css']
})
export class GraphInteractionComponent implements OnInit {
    height: number = 600;
    width: number = 600;
    cellSize: number = 30;
    PX: number = 8;
    PY: number = 8;
    NX: number = -8;
    NY: number = -8;
    xInterval: number = 1;
    yInterval: number = 1;
    xValue: number[] = new Array();
    yValue: number[] = new Array();
    graphTypeSelected = "POINT";
    graph: GraphPoints[] = new Array();
    undo: GraphPoints[] = new Array();
    unDoDelete: GraphPoints[] = new Array();
    segmentItem: Coordinates[] = new Array();
    circleItem: Coordinates[] = new Array();
    color: string = "#00bfff";
    pointCSS = "";
    segmentCSS = "";
    circleCSS = "";
    graphLayoutDetails: any;
    isSelectDelete: boolean = false;
    viewTypeSelected: string = 'ALL';
    allSide: number = 8;
    commonInterval: number = 1;
    isChangeAllSide: boolean = false;
    graphLengthOnDelete: number[] = new Array();
    @ViewChild('myCanvas') myCanvas: ElementRef;
    public context: CanvasRenderingContext2D;
    public contextCord: CanvasRenderingContext2D;
    @Input() item: any;
    QuestionDetail: any;
    @Output() graphDetails = new EventEmitter<any[]>();
    itemID: any;

    constructor() { }

    ngOnInit() {
        this.contextCord = (<HTMLCanvasElement>this.myCanvas.nativeElement).getContext('2d');
        this.context = (<HTMLCanvasElement>this.myCanvas.nativeElement).getContext('2d');
        if (this.item != null) {
            this.QuestionDetail = this.item;
            this.itemID = 'Canvas_' + this.QuestionDetail.ID;
            this.myCanvas.nativeElement.id = this.itemID;
            this.myCanvas.nativeElement.attributes.ChoiceID = this.QuestionDetail.ID;
            let grphLayoutDetails: GraphLayoutDetail = new GraphLayoutDetail(this.cellSize, this.viewTypeSelected, this.NX, this.PX, this.NY, this.PY, this.xInterval, this.yInterval);
            this.QuestionDetail.graphLayoutDetails = grphLayoutDetails;
            if (this.QuestionDetail.QuestionAttributes != null && this.QuestionDetail.QuestionAttributes != '') {
                let grphLayout: any;
                grphLayout = this.QuestionDetail.QuestionAttributes;
                if (grphLayout.GraphSize != null) {
                    this.QuestionDetail.graphLayoutDetails = grphLayoutDetails;
                } else {
                    let grphLayoutDetails: GraphLayoutDetail = new GraphLayoutDetail(parseInt(grphLayout.cellSize), grphLayout.quadView, parseFloat(grphLayout.XN), parseFloat(grphLayout.XP), parseFloat(grphLayout.YN), parseFloat(grphLayout.YP), parseFloat(grphLayout.xInterval), parseFloat(grphLayout.yInterval));
                    this.QuestionDetail.graphLayoutDetails = grphLayoutDetails;
                    this.cellSize = this.QuestionDetail.graphLayoutDetails.cellSize;
                    this.viewTypeSelected = this.QuestionDetail.graphLayoutDetails.quadView;
                    this.NX = this.QuestionDetail.graphLayoutDetails.XN;
                    this.PX = this.QuestionDetail.graphLayoutDetails.XP;
                    this.NY = this.QuestionDetail.graphLayoutDetails.YN;
                    this.PY = this.QuestionDetail.graphLayoutDetails.YP;
                    this.xInterval = this.QuestionDetail.graphLayoutDetails.xInterval;
                    this.yInterval = this.QuestionDetail.graphLayoutDetails.yInterval;
                    if (this.NX == this.NY && this.PY == this.PX && this.NX == (this.PY * -1)) {
                        this.allSide = this.PX;
                    }
                    if (this.xInterval == this.yInterval) {
                        this.commonInterval = this.xInterval;
                    }
                }
            }
            if (this.QuestionDetail.graphDetails != null && this.QuestionDetail.graphDetails != "")
                this.restoreData();
            else
                this.calculateValues();

        }
    }

    restoreData() {
        var temp: string[];
        temp = this.QuestionDetail.graphDetails.split(";");
        this.QuestionDetail.graphDetails = "";
        this.graph.length = 0;
        this.segmentItem.length = 0;
        this.circleItem.length = 0;
        this.calculateValues();
        for (let i = 0; i < temp.length - 1; i++) {
            let graphItem: Coordinates = new Coordinates();
            if (temp[i].search('GraphPoints') >= 0) {
                this.graphTypeSelected = "POINT";
                var frstIndex: number = temp[i].indexOf('#') + 1;
                var secdIndex: number = temp[i].indexOf(',');
                var X = parseFloat(temp[i].slice(frstIndex, secdIndex));
                frstIndex = secdIndex + 1;
                var Y = parseFloat(temp[i].slice(frstIndex));
                graphItem.canvasX = X;
                graphItem.canvasY = Y;
                if (X > this.PX || X < this.NX || Y > this.PY || Y < this.NY) {
                    this.dynamicGraphLayoutChange(graphItem);
                }
                this.redirectGraph(this.valueToCords(graphItem));
            }
            else if (temp[i].search('Circle') >= 0) {
                this.graphTypeSelected = "CIRCLE";
                this.restoreMultiPoints(temp[i]);
            }
            else if (temp[i].search('Line') >= 0) {
                this.graphTypeSelected = "SEGMENT";
                this.restoreMultiPoints(temp[i]);
            }

        }
    }

    dynamicGraphLayoutChange(graphItem: Coordinates) {
        if (graphItem.canvasX > this.PX)
            this.PX = graphItem.canvasX;
        if (graphItem.canvasX < this.NX)
            this.NX = graphItem.canvasX;
        if (graphItem.canvasY > this.PY)
            this.PY = graphItem.canvasY;
        if (graphItem.canvasY < this.NY)
            this.NY = graphItem.canvasY;
        this.calculateValues();
    }

    restoreMultiPoints(temp: string) {
        let graphItem: Coordinates = new Coordinates();
        var frstIndex: number = temp.indexOf('#') + 1;
        var secdIndex: number = temp.indexOf(',');
        var X = parseFloat(temp.slice(frstIndex, secdIndex));
        frstIndex = secdIndex + 1;
        secdIndex = temp.indexOf(':');
        let Y = (parseFloat(temp.slice(frstIndex, secdIndex)));
        graphItem.canvasX = X;
        graphItem.canvasY = Y;
        if (X > this.PX || X < this.NX || Y > this.PY || Y < this.NY) {
            this.dynamicGraphLayoutChange(graphItem);
        }
        this.redirectGraph(this.valueToCords(graphItem));
        frstIndex = secdIndex + 1;
        secdIndex = temp.indexOf(',', frstIndex);
        let X2 = parseFloat(temp.slice(frstIndex, secdIndex));
        let Y2 = parseFloat(temp.slice(secdIndex + 1));
        let graphItem2: Coordinates = new Coordinates();
        graphItem2.canvasX = X2;
        graphItem2.canvasY = Y2;
        if (X2 > this.PX || X2 < this.NX || Y2 > this.PY || Y2 < this.NY) {
            this.dynamicGraphLayoutChange(graphItem2);
            this.redirectGraph(this.valueToCords(graphItem));
        }
        this.redirectGraph(this.valueToCords(graphItem2));
    }

    resetAll() {
        this.myCanvas.nativeElement.width = this.width;
        this.myCanvas.nativeElement.height = this.height;
        this.QuestionDetail.graphDetails = "";
        this.graph.length = 0;
        this.segmentItem.length = 0;
        this.circleItem.length = 0;
        this.undo.length = 0;
        this.unDoDelete.length = 0;
        this.drawGraph();
    }

    reset() {
        this.myCanvas.nativeElement.width = this.width;
        this.myCanvas.nativeElement.height = this.height;
        this.QuestionDetail.graphDetails = "";
        this.graph.length = 0;
        this.segmentItem.length = 0;
        this.circleItem.length = 0;
        this.drawGraph();
    }

    unDoGraph() {
        if (this.unDoDelete.length > 0 && (this.graphLengthOnDelete[this.graphLengthOnDelete.length - 1] == this.graph.length)) {
            this.graphLengthOnDelete.pop();
            this.graph.push(this.unDoDelete.pop());
            this.restoreGraph();
        }
        else if (this.segmentItem.length == 1 || this.circleItem.length == 1)
            this.restoreGraph();
        else if (this.graph.length > 0) {
            this.undo.push(this.graph.pop());
            if (this.graph.length == 0) {
                this.reset();
            }
            else
                this.restoreGraph();
        }
    }

    reDoGraph() {
        if (this.undo.length > 0) {
            this.graph.push(this.undo.pop());
            this.restoreGraph();
        }
    }

    selectDelete() {
        this.isSelectDelete = true;
        if (this.graph.length > 0) {
            this.color = "black";
            this.restoreGraph();
        }
        else if (this.segmentItem.length == 1 || this.circleItem.length == 1) {
            this.restoreGraph();
        }
    }
    deleteSelectedItem(Item: Coordinates) {
        this.isSelectDelete = false;
        let Points: Coordinates = new Coordinates();
        let x: number;
        let y: number;
        x = (Item.canvasX - this.cellSize) / this.cellSize;
        Points.canvasX = this.xValue[x];
        y = (Item.canvasY - this.cellSize) / this.cellSize;
        Points.canvasY = this.yValue[y];
        for (let i = 0; i < this.graph.length; i++) {
            if (Points.canvasX == this.graph[i].graphPoints[0].canvasX && Points.canvasY == this.graph[i].graphPoints[0].canvasY) {
                this.unDoDelete.push(this.graph[i]);
                this.graph.splice(i, 1);
                this.graphLengthOnDelete.push(this.graph.length);
                break;
            }
            else if (this.graph[i].graphPoints.length == 2 && (Points.canvasX == this.graph[i].graphPoints[1].canvasX && Points.canvasY == this.graph[i].graphPoints[1].canvasY)) {
                this.unDoDelete.push(this.graph[i]);
                this.graph.splice(i, 1);
                this.graphLengthOnDelete.push(this.graph.length);
                break;
            }
        }
        this.color = "#00bfff";
        this.restoreGraph();
    }

    restoreGraph() {
        let tempGraph: any = this.graph.slice();
        let tempGraphTypeSelected: string = this.graphTypeSelected;
        this.reset();
        for (let i = 0; i < tempGraph.length; i++) {
            if (tempGraph[i].type == "POINT") {
                this.graphTypeSelected = "POINT";
                let graphItem: Coordinates = new Coordinates();
                graphItem = this.valueToCords(tempGraph[i].graphPoints[0]);
                if (graphItem.canvasX != null && graphItem.canvasY != null) {
                    this.redirectGraph(graphItem);
                }
            }
            else if (tempGraph[i].type == "SEGMENT") {
                this.graphTypeSelected = "SEGMENT";
                let graphItem: Coordinates = new Coordinates();
                let graphItem2: Coordinates = new Coordinates();
                graphItem = this.valueToCords(tempGraph[i].graphPoints[0]);
                graphItem2 = this.valueToCords(tempGraph[i].graphPoints[1]);
                if (graphItem2.canvasX != null && graphItem2.canvasY != null && graphItem.canvasX != null && graphItem.canvasY != null) {
                    this.redirectGraph(graphItem);
                    this.redirectGraph(graphItem2);
                }
            }
            else if (tempGraph[i].type == "CIRCLE") {
                this.graphTypeSelected = "CIRCLE";
                let graphItem: Coordinates = new Coordinates();
                let graphItem2: Coordinates = new Coordinates();
                graphItem = this.valueToCords(tempGraph[i].graphPoints[0]);
                graphItem2 = this.valueToCords(tempGraph[i].graphPoints[1]);
                if (graphItem2.canvasX != null && graphItem2.canvasY != null && graphItem.canvasX != null && graphItem.canvasY != null) {
                    this.redirectGraph(graphItem);
                    this.redirectGraph(graphItem2);
                }
            }
        }
        this.graphTypeSelected = tempGraphTypeSelected;
    }

    valueToCords(graphItem: Coordinates) {
        let value: Coordinates = new Coordinates();
        for (let i = 0; i < this.xValue.length; i++) {
            if (this.xValue[i] == graphItem.canvasX)
                value.canvasX = (i * this.cellSize) + this.cellSize;
        }
        for (let i = 0; i < this.yValue.length; i++) {
            if (this.yValue[i] == graphItem.canvasY)
                value.canvasY = (i * this.cellSize) + this.cellSize;
        }
        return value;
    }

    graphValidation(graphItem: Coordinates) {
        if (this.graphTypeSelected == 'POINT') {
            for (let i = 0; i < this.graph.length; i++) {
                if (this.graph[i].type == this.graphTypeSelected) {
                    if (this.graph[i].coords[0].canvasX == graphItem.canvasX && this.graph[i].coords[0].canvasY == graphItem.canvasY)
                        return false;
                }
            }
        } else if (this.graphTypeSelected == 'SEGMENT' && this.segmentItem.length > 0) {
            if (this.segmentItem[0].canvasX == graphItem.canvasX && this.segmentItem[0].canvasY == graphItem.canvasY)
                return false;
            else {
                for (let i = 0; i < this.graph.length; i++) {
                    if (this.graph[i].type == 'SEGMENT') {
                        if ((this.graph[i].coords[0].canvasX == this.segmentItem[0].canvasX && this.graph[i].coords[0].canvasY == this.segmentItem[0].canvasY) && (this.graph[i].coords[1].canvasX == graphItem.canvasX && this.graph[i].coords[1].canvasY == graphItem.canvasY))
                            return false;
                        else if ((this.graph[i].coords[1].canvasX == this.segmentItem[0].canvasX && this.graph[i].coords[1].canvasY == this.segmentItem[0].canvasY) && (this.graph[i].coords[0].canvasX == graphItem.canvasX && this.graph[i].coords[0].canvasY == graphItem.canvasY))
                            return false
                    }
                }
            }
        } else if (this.graphTypeSelected == 'CIRCLE' && this.circleItem.length > 0) {
            if (this.circleItem[0].canvasX == graphItem.canvasX && this.circleItem[0].canvasY == graphItem.canvasY)
                return false;
            else {
                let tempCircleItem: Coordinates[] = new Array();
                tempCircleItem.push(this.circleItem[0]);
                tempCircleItem.push(graphItem);
                let currentCircleDist: string = this.getDistance(tempCircleItem);
                for (let i = 0; i < this.graph.length; i++) {
                    if (this.graph[i].type == 'CIRCLE') {
                        let circleDist: string = this.getDistance(this.graph[i].coords);
                        if (circleDist == currentCircleDist && this.circleItem[0].canvasX == this.graph[i].coords[0].canvasX && this.circleItem[0].canvasY == this.graph[i].coords[0].canvasY)
                            return false;
                    }
                }
            }
        }
        return true;
    }

    mouseCoords(event: MouseEvent) {
        var top = (<HTMLCanvasElement>this.myCanvas.nativeElement).getBoundingClientRect().top;
        var left = (<HTMLCanvasElement>this.myCanvas.nativeElement).getBoundingClientRect().left;

        let graphItem: Coordinates = new Coordinates();
        this.contextCord = (<HTMLCanvasElement>this.myCanvas.nativeElement).getContext('2d');

        graphItem.canvasX = Math.round((event.clientX - left) / this.cellSize) * this.cellSize;
        graphItem.canvasY = Math.round((event.clientY - top) / this.cellSize) * this.cellSize;
        if (graphItem.canvasX == 0)
            graphItem.canvasX = this.cellSize;
        if (graphItem.canvasY == 0)
            graphItem.canvasY = this.cellSize;
        if (graphItem.canvasX == this.width)
            graphItem.canvasX = this.width - this.cellSize;
        if (graphItem.canvasY == this.height)
            graphItem.canvasY = this.height - this.cellSize;
        if (!this.isSelectDelete)
            this.redirectGraph(graphItem);
        else
            this.deleteSelectedItem(graphItem);
    }

    redirectGraph(graphItem: Coordinates) {
        switch (this.graphTypeSelected) {
            case 'POINT':
                if (this.graphValidation(graphItem)) {
                    this.drawPoint(graphItem);
                    this.storePoint(graphItem);
                } else {
                    alert("Two points can not be same!");
                }
                break;
            case 'SEGMENT':
                if (this.graphValidation(graphItem)) {
                    this.drawPoint(graphItem);
                    this.segmentItem.push(graphItem);
                    if (this.segmentItem.length == 2) {
                        this.drawSegment(this.segmentItem);
                        this.segmentItem.length = 0;
                    }
                } else if (this.segmentItem.length > 0) {
                    alert("Line can not have two same points!");
                }
                break;
            case 'CIRCLE':

                if (this.graphValidation(graphItem)) {
                    this.drawPoint(graphItem);
                    this.circleItem.push(graphItem);
                    if (this.circleItem.length == 2) {
                        this.drawCircle(this.circleItem);
                        this.circleItem.length = 0;
                    }
                } else
                    if (this.circleItem.length == 1) {
                        alert("Circle can not have same point with same distance!");
                    }
                break;
        }
    }
    drawSegment(cords: Coordinates[]) {
        this.contextCord.moveTo(cords[0].canvasX, cords[0].canvasY);
        this.contextCord.lineTo(cords[1].canvasX, cords[1].canvasY);
        this.contextCord.lineWidth = 1;
        this.context.strokeStyle = this.color;
        this.contextCord.stroke();
        this.storeMultiplePoints(cords, 'SEGMENT');
    }

    storeMultiplePoints(cords: Coordinates[], type: string) {
        let graphPoint: GraphPoints = new GraphPoints();
        let coord: Coordinates[] = new Array();
        let graphCord: Coordinates[] = new Array();
        let cordPoints: Coordinates = new Coordinates();
        let cordPoints2: Coordinates = new Coordinates();
        let x: number;
        let y: number;
        x = (cords[0].canvasX - this.cellSize) / this.cellSize;
        cordPoints.canvasX = this.xValue[x];
        y = (cords[0].canvasY - this.cellSize) / this.cellSize;
        cordPoints.canvasY = this.yValue[y];
        graphCord.push(cordPoints);
        let x1: number;
        let y1: number;
        x1 = (cords[1].canvasX - this.cellSize) / this.cellSize;
        cordPoints2.canvasX = this.xValue[x1];
        y1 = (cords[1].canvasY - this.cellSize) / this.cellSize;
        cordPoints2.canvasY = this.yValue[y1];
        graphCord.push(cordPoints2);
        coord.push(cords[0]);
        coord.push(cords[1]);
        graphPoint.coords = coord;
        graphPoint.graphPoints = graphCord;
        graphPoint.type = type;
        if (type == 'SEGMENT') {
            if ((cordPoints.canvasX > cordPoints2.canvasX) || ((cordPoints.canvasX == cordPoints2.canvasX) && (cordPoints.canvasY > cordPoints2.canvasY))) {
                let temp: any;
                temp = cordPoints;
                cordPoints = cordPoints2;
                cordPoints2 = temp;
            }
            this.QuestionDetail.graphDetails += 'Line#' + (cordPoints.canvasX > 0 ? ('+' + cordPoints.canvasX) : cordPoints.canvasX) + "," + (cordPoints.canvasY > 0 ? ('+' + cordPoints.canvasY) : cordPoints.canvasY) + ":" + (cordPoints2.canvasX > 0 ? ('+' + cordPoints2.canvasX) : cordPoints2.canvasX) + "," + (cordPoints2.canvasY > 0 ? ('+' + cordPoints2.canvasY) : cordPoints2.canvasY) + ";"
        }
        else {
            graphPoint.radiusOfCircle = this.getDistance(graphCord);
            this.QuestionDetail.graphDetails += 'Circle#' + (cordPoints.canvasX > 0 ? ('+' + cordPoints.canvasX) : cordPoints.canvasX) + "," + (cordPoints.canvasY > 0 ? ('+' + cordPoints.canvasY) : cordPoints.canvasY) + ":" + (cordPoints2.canvasX > 0 ? ('+' + cordPoints2.canvasX) : cordPoints2.canvasX) + "," + (cordPoints2.canvasY > 0 ? ('+' + cordPoints2.canvasY) : cordPoints2.canvasY) + ":" + graphPoint.radiusOfCircle + ";"
        }
        this.graphDetails.emit(this.QuestionDetail.graphDetails);
        this.graph.push(graphPoint);
    }

    storePoint(cords: Coordinates) {
        let cordPoints: Coordinates = new Coordinates();
        let graphPoint: GraphPoints = new GraphPoints();
        let coord: Coordinates[] = new Array();
        let graphCord: Coordinates[] = new Array();
        coord.push(cords);
        graphPoint.coords = coord;
        graphPoint.type = "POINT";
        let x: number;
        let y: number;
        x = (cords.canvasX - this.cellSize) / this.cellSize;
        cordPoints.canvasX = this.xValue[x];
        y = (cords.canvasY - this.cellSize) / this.cellSize;
        cordPoints.canvasY = this.yValue[y];
        this.QuestionDetail.graphDetails += 'GraphPoints#' + (cordPoints.canvasX > 0 ? ('+' + cordPoints.canvasX) : cordPoints.canvasX) + "," + (cordPoints.canvasY > 0 ? ('+' + cordPoints.canvasY) : cordPoints.canvasY) + ";"
        graphCord.push(cordPoints);
        graphPoint.graphPoints = graphCord;
        this.graphDetails.emit(this.QuestionDetail.graphDetails);
        this.graph.push(graphPoint);
    }

    drawPoint(cords: Coordinates) {
        let cordPoints: Coordinates = new Coordinates();
        this.contextCord.beginPath();
        this.contextCord.arc(cords.canvasX, cords.canvasY, 5, 0, 2 * Math.PI);
        this.contextCord.lineWidth = 0.1;
        this.contextCord.fillStyle = this.color;
        this.contextCord.fill();
        this.context.strokeStyle = this.color;
        let x: number;
        let y: number;
        x = (cords.canvasX - this.cellSize) / this.cellSize;
        cordPoints.canvasX = this.xValue[x];
        y = (cords.canvasY - this.cellSize) / this.cellSize;
        cordPoints.canvasY = this.yValue[y];
        //this.contextCord.fillStyle = "black";
        this.contextCord.font = "10px Arial";
        let pointValue = "(" + (cordPoints.canvasX > 0 ? ('+' + cordPoints.canvasX) : cordPoints.canvasX) + "," + (cordPoints.canvasY > 0 ? ('+' + cordPoints.canvasY) : cordPoints.canvasY) + ")";
        this.contextCord.fillText(pointValue, cords.canvasX - 15, cords.canvasY - 10);
        this.contextCord.stroke();
    }

    graphType(type: string) {
        this.graphTypeSelected = type;
        switch (this.graphTypeSelected) {
            case 'POINT':
                this.pointCSS = "background-color:green;";
                this.segmentCSS = "";
                this.circleCSS = "";
                break;
            case 'SEGMENT':
                this.pointCSS = "";
                this.segmentCSS = "background-color:green;";
                this.circleCSS = "";
                break;
            case 'CIRCLE':
                this.pointCSS = "";
                this.segmentCSS = "";
                this.circleCSS = "background-color:green;";
                break;
        }
    }

    drawCircle(cords: Coordinates[]) {
        this.contextCord.beginPath();
        let dist: number = Math.pow(((Math.pow((cords[0].canvasX - cords[1].canvasX), 2)) + (Math.pow((cords[0].canvasY - cords[1].canvasY), 2))), 1 / 2)
        this.contextCord.arc(cords[0].canvasX, cords[0].canvasY, dist, 0, 2 * Math.PI);
        this.contextCord.lineWidth = 1;
        this.context.strokeStyle = this.color;
        this.contextCord.stroke();
        this.storeMultiplePoints(cords, 'CIRCLE');
    }

    calculateValues() {
        this.xValue.length = 0;
        this.yValue.length = 0;
        if (this.PX == null || this.PX < 0)
            this.PX = 8;
        if (this.PY == null || this.PY < 0)
            this.PY = 8;
        if (this.NX == null || this.NX > 0)
            this.NX = -8;
        if (this.NY == null || this.NY > 0)
            this.NY = -8;
        if (this.xInterval == null || this.xInterval <= 0)
            this.xInterval = 1;
        if (this.yInterval == null || this.yInterval <= 0)
            this.yInterval = 1;
        if (this.NX != null && this.PX != null) {
            let count: number = 0
            this.xValue.push(count);
            while (count > this.NX) {
                count = parseFloat((count - this.xInterval).toFixed(2));
                this.xValue.push(count);
            }
            this.xValue.reverse();
            count = 0;
            while (count < this.PX) {
                count = parseFloat((count + this.xInterval).toFixed(2));
                this.xValue.push(count);
            }
        }
        if (this.PY != null && this.NY != null) {
            let count: number = 0
            this.yValue.push(count);
            while (count < this.PY) {
                count = parseFloat((count + this.yInterval).toFixed(2));
                this.yValue.push(count);
            }
            this.yValue.reverse();
            count = 0;
            while (count > this.NY) {
                count = parseFloat((count - this.yInterval).toFixed(2));
                this.yValue.push(count);
            }
        }
        this.height = (this.yValue.length + 1) * this.cellSize;
        this.width = (this.xValue.length + 1) * this.cellSize;
        this.myCanvas.nativeElement.width = this.width;
        this.myCanvas.nativeElement.height = this.height;
        this.QuestionDetail.graphLayoutDetails.cellSize = this.cellSize;
        this.QuestionDetail.graphLayoutDetails.quadView = this.viewTypeSelected;
        this.QuestionDetail.graphLayoutDetails.XN = this.NX;
        this.QuestionDetail.graphLayoutDetails.XP = this.PX
        this.QuestionDetail.graphLayoutDetails.YN = this.NY;
        this.QuestionDetail.graphLayoutDetails.YP = this.PY;
        this.QuestionDetail.graphLayoutDetails.xInterval = this.xInterval;
        this.QuestionDetail.graphLayoutDetails.yInterval = this.yInterval;
        this.restoreGraph();
    }

    drawGraph() {
        let xCount: number = 0;
        let yCount: number = 0;
        let xSpace: number = 0;
        let ySpace: number = 0;
        while (this.xValue[xSpace] != 0) {
            xSpace++;
        }
        while (this.yValue[ySpace] != 0) {
            ySpace++;
        }
        let yLinePlace: number;
        yLinePlace = (xSpace + 1) * this.cellSize;
        let xLinePlace: number;
        xLinePlace = (ySpace + 1) * this.cellSize;
        this.context = (<HTMLCanvasElement>this.myCanvas.nativeElement).getContext('2d');
        for (let i = this.cellSize; i < this.height; i = i + this.cellSize) {
            this.context.lineWidth = 0.3;
            this.context.moveTo(this.cellSize, i);
            this.context.lineTo(this.width - this.cellSize, i);
            this.context.font = "12px Arial";
            if (this.yValue[yCount] >= 0) {
                if (this.yValue[yCount] != 0) {
                    if (this.viewTypeSelected == '++')
                        this.context.fillText(this.yValue[yCount].toString(), yLinePlace - 25, i + 5);
                    else
                        this.context.fillText(this.yValue[yCount].toString(), yLinePlace + 7, i + 5);
                    this.context.moveTo(yLinePlace - 5, i);
                    this.context.lineTo(yLinePlace + 5, i);
                    this.context.moveTo(yLinePlace - 5, i);
                    this.context.lineTo(yLinePlace + 5, i);
                }
                else
                    this.context.fillText(this.yValue[yCount].toString(), yLinePlace, i);
            }
            else {
                if (this.viewTypeSelected == '--')
                    this.context.fillText(this.yValue[yCount].toString(), yLinePlace + 7, i + 5);
                else {
                    if (this.yValue[yCount] > -10)
                        this.context.fillText(this.yValue[yCount].toString(), yLinePlace - 22, i + 5);
                    else
                        this.context.fillText(this.yValue[yCount].toString(), yLinePlace - 25, i + 5);
                }
                this.context.moveTo(yLinePlace - 5, i);
                this.context.lineTo(yLinePlace + 5, i);
                this.context.moveTo(yLinePlace - 5, i);
                this.context.lineTo(yLinePlace + 5, i);
            }
            yCount++;
        }
        for (let i = this.cellSize; i < this.width; i = i + this.cellSize) {
            this.context.moveTo(i, this.cellSize);
            this.context.lineTo(i, this.height - this.cellSize);
            if (this.xValue[xCount] <= 0) {
                if (this.xValue[xCount] != 0) {
                    if (this.viewTypeSelected == '-+')
                        this.context.fillText(this.xValue[xCount].toString(), i - 5, xLinePlace + 20);
                    else
                        this.context.fillText(this.xValue[xCount].toString(), i - 8, xLinePlace - 7);
                    this.context.moveTo(i, xLinePlace + 5);
                    this.context.lineTo(i, xLinePlace - 5);
                    this.context.moveTo(i, xLinePlace + 5);
                    this.context.lineTo(i, xLinePlace - 5);
                }
                else
                    this.context.fillText(this.xValue[xCount].toString(), i, xLinePlace);
            }
            else {
                if (this.viewTypeSelected == '+-')
                    this.context.fillText(this.xValue[xCount].toString(), i - 8, xLinePlace - 7);
                else
                    this.context.fillText(this.xValue[xCount].toString(), i - 5, xLinePlace + 20);
                this.context.moveTo(i, xLinePlace + 5);
                this.context.lineTo(i, xLinePlace - 5);
                this.context.moveTo(i, xLinePlace + 5);
                this.context.lineTo(i, xLinePlace - 5);
            }
            xCount++;
        }
        this.context.fillStyle = "#00bfff";
        if (this.viewTypeSelected == '++' || this.viewTypeSelected == 'ALL') {
            this.context.fillText("+X", this.width - 25, xLinePlace - 5);
            this.context.fillText("+Y", yLinePlace - 20, 20);
        }
        if (this.viewTypeSelected == '--' || this.viewTypeSelected == 'ALL') {
            this.context.fillText("-Y", yLinePlace + 10, this.height - 10);
            this.context.fillText("-X", 10, xLinePlace + 15);
        }
        if (this.viewTypeSelected == '+-') {
            this.context.fillText("+X", this.width - 25, xLinePlace - 5);
            this.context.fillText("-Y", yLinePlace + 10, this.height - 10);
        }
        if (this.viewTypeSelected == '-+') {
            this.context.fillText("-X", 10, xLinePlace + 15);
            this.context.fillText("+Y", yLinePlace - 20, 20);
        }
        this.context.moveTo(yLinePlace, 0);
        this.context.lineTo(yLinePlace, this.height);
        this.context.moveTo(0, xLinePlace);
        this.context.lineTo(this.width, xLinePlace);
        this.context.strokeStyle = "red";
        this.context.stroke();
        this.drawArrow("++", xLinePlace, "red");
        this.drawArrow("--", xLinePlace, "red");
        this.drawArrow("-+", yLinePlace, "red");
        this.drawArrow("+-", yLinePlace, "red");
    }

    drawArrow(type: string, place: number, color: string) {
        if (type == "++") {
            this.contextCord.beginPath();
            this.contextCord.moveTo(this.width, place);
            this.contextCord.lineTo(this.width - 5, place - 5);
            this.contextCord.lineTo(this.width - 5, place + 5);
            this.contextCord.fillStyle = color;
            this.contextCord.fill();
            this.contextCord.stroke();
        } else if (type == "--") {
            this.contextCord.moveTo(0, place);
            this.contextCord.lineTo(5, place - 5);
            this.contextCord.lineTo(5, place + 5);
            this.contextCord.fillStyle = color;
            this.contextCord.fill();
            this.contextCord.stroke();
        } else if (type == "-+") {
            this.contextCord.moveTo(place, 0);
            this.contextCord.lineTo(place - 5, 5);
            this.contextCord.lineTo(place + 5, 5);
            this.contextCord.fillStyle = color;
            this.contextCord.fill();
            this.contextCord.stroke();
        } else if (type == "+-") {
            this.contextCord.moveTo(place, this.height);
            this.contextCord.lineTo(place - 5, this.height - 5);
            this.contextCord.lineTo(place + 5, this.height - 5);
            this.contextCord.fillStyle = color;
            this.contextCord.fill();
            this.contextCord.stroke();
        }
    }

    getDistance(cords: Coordinates[]) {
        let dist: number = Math.pow(((Math.pow((cords[0].canvasX - cords[1].canvasX), 2)) + (Math.pow((cords[0].canvasY - cords[1].canvasY), 2))), 1 / 2);
        return dist.toFixed(2);
    }
}



// WEBPACK FOOTER //
// E:/Workspace/TestandAssessment/Manifest/TestPlayer/TestDelivery.TestPlayer/src/app/Test/QuestionTypes/GraphInteraction/GraphInteraction.component.ts